'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of testimonial
 */ const Testimonial = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                opacity: "0.7",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M78.0809 43.5352C83.0591 43.5352 87.0947 47.5708 87.0947 52.5489V68.0703C87.0947 72.8177 83.4246 76.7079 78.7669 77.0584L78.7548 82.5057C78.7509 84.2621 76.5947 85.1021 75.4036 83.8112L69.79 77.727C69.607 77.5286 69.4759 77.3105 69.3916 77.0841H57.5042C52.5261 77.0841 48.4905 73.0485 48.4905 68.0703V52.5489C48.4905 47.5708 52.5261 43.5352 57.5042 43.5352H78.0809Z",
                    fill: theme.ds5.asset[assetColor]["500"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.9845 22.6035C21.0063 22.6035 16.9707 26.6391 16.9707 31.6173V59.0432C16.9707 64.0213 21.0063 68.0569 25.9845 68.0569H28.2524L28.2726 77.1439C28.2765 78.9003 30.4327 79.7403 31.6237 78.4494L41.2124 68.0569H60.2595C65.2377 68.0569 69.2733 64.0213 69.2733 59.0431V31.6173C69.2733 26.6391 65.2377 22.6035 60.2595 22.6035H25.9845Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M32.1933 46.5708H25.9736V41.792C25.9736 40.0326 26.3406 38.6446 27.0745 37.6259C27.8084 36.6084 29.0668 35.7093 30.8497 34.9297L32.1933 37.4687C31.0968 37.9824 30.3392 38.4938 29.9194 39.0021C29.4995 39.5114 29.2664 40.1122 29.2189 40.8068H32.1933V46.5697V46.5708ZM39.4426 46.5708H33.2229V41.792C33.2229 40.0326 33.5899 38.6446 34.3238 37.6259C35.0577 36.6084 36.3161 35.7093 38.099 34.9297L39.4426 37.4687C38.3461 37.9824 37.5885 38.4938 37.1687 39.0021C36.7488 39.5114 36.5157 40.1122 36.4682 40.8068H39.4426V46.5697V46.5708Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M54.003 46.5699L60.2227 46.5699L60.2227 51.3486C60.2227 53.1081 59.8557 54.496 59.1218 55.5147C58.3879 56.5322 57.1295 57.4313 55.3466 58.2109L54.003 55.6719C55.0995 55.1583 55.8571 54.6468 56.2769 54.1386C56.6968 53.6292 56.9299 53.0284 56.9774 52.3339L54.003 52.3339L54.003 46.5709L54.003 46.5699ZM46.7536 46.5699L52.9734 46.5699L52.9734 51.3486C52.9734 53.1081 52.6064 54.496 51.8725 55.5147C51.1386 56.5322 49.8802 57.4313 48.0973 58.2109L46.7536 55.6719C47.8502 55.1583 48.6078 54.6468 49.0276 54.1386C49.4474 53.6292 49.6806 53.0284 49.7281 52.3339L46.7536 52.3339L46.7536 46.5709L46.7536 46.5699Z",
                fill: theme.ds5.asset[assetColor]["300"]
            })
        ]
    });
};

exports.Testimonial = Testimonial;
//# sourceMappingURL=Testimonial.cjs.map
